import { useEffect } from "react";
import { CountriesCard } from "./card";
import { CountriesNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { CountriesTable } from "./table";

export default function Country() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Pays");
  }, []);

  return (
    <Routes>
      <Route index element={<CountriesTable />} />
      <Route path="/new" element={<CountriesNew />} />
      <Route path=":id" element={<CountriesCard />} />
    </Routes>
  );
}
